import React from "react";

import { useTranslation } from "react-i18next";
import Select from "react-select";
import { isEmpty } from "lodash";
import { getReactSelectTheme } from "../../utils/ReactSelectStyles";

const SelectParameterForm = ({
    isBundle,
    parameters,
    bundleProducts,
    selectedParameter,
    setSelectedParameter,
    selectedBundleProduct,
    setSelectedBundleProduct,
    productParameters,
    setProductParameters,
}) => {
    const { t } = useTranslation();

    const handleProductChange = (val) => {
        setSelectedParameter(null);
        setSelectedBundleProduct(val);
        setProductParameters(val.parameters);
    };

    const fields = [
        {
            hide: !isBundle,
            label: t("product"),
            element: () => (
                <Select
                    options={bundleProducts}
                    value={selectedBundleProduct}
                    onChange={handleProductChange}
                    placeholder={t("selectPlaceholder", {
                        entity: t("product"),
                    })}
                    theme={getReactSelectTheme}
                    menuPosition="fixed"
                    menuShouldScrollIntoView={false}
                />
            ),
        },
        {
            label: t("parameter"),
            element: () => (
                <Select
                    options={isBundle ? productParameters : parameters}
                    value={selectedParameter}
                    isDisabled={
                        isBundle
                            ? isEmpty(productParameters)
                            : isEmpty(parameters)
                    }
                    onChange={(val) => setSelectedParameter(val)}
                    placeholder={t("selectPlaceholder", {
                        entity: t("parameter"),
                    })}
                    theme={getReactSelectTheme}
                    menuPosition="fixed"
                    menuShouldScrollIntoView={false}
                />
            ),
        },
    ];

    const renderFields = () => {
        return (
            fields &&
            fields.map((field, index) => {
                if (!field.hide) {
                    return (
                        <div className="tags input-group" key={index}>
                            <h4 className="uppercase text-xs required">
                                {field.label}
                            </h4>

                            {field.element()}
                        </div>
                    );
                }
            })
        );
    };

    return <>{renderFields()}</>;
};

export default SelectParameterForm;
